<div class="busqueda-telefono">
  <app-page-title
    title="Buscar por teléfono"
    subtitle="Buscá un número de teléfono en contactos, alarmas, trackers y demás entidades"
    icon="phone"
    color="blue"
  ></app-page-title>

  <!-- Buscador (mismo estilo que el de las tablas) -->
  <div class="busqueda-search">
    <mat-icon>search</mat-icon>
    <input
      type="text"
      autocomplete="off"
      placeholder="Buscar por teléfono"
      [ngModel]="termino"
      (ngModelChange)="onTerminoChange($event)"
    />
    @if (termino) {
      <button
        irxBotonIcono
        tamano="mini"
        tooltip="Limpiar búsqueda"
        (click)="limpiar()"
      >
        <mat-icon>close</mat-icon>
      </button>
    }
  </div>

  <!-- Resultados -->
  @if (buscando) {
    <app-loading text="Buscando..."></app-loading>
  } @else if (busco && resultados.length === 0) {
    <app-empty-state
      icon="phone_disabled"
      title="Sin resultados"
      [message]="
        'No se encontró ninguna entidad con el teléfono \'' + termino + '\''
      "
    ></app-empty-state>
  } @else if (resultados.length > 0) {
    <div class="resultados-grid">
      @for (r of resultados; track $index) {
        <div [class]="'resultado-card tipo-' + colorActivo(r)">
          <!-- Ícono izquierdo. Si hay entidad asignada, son dos íconos que
               alternan la vista (y cambian el color de la tarjeta). -->
          @if (r.asignadoEntidad) {
            <div class="resultado-card-toggle">
              <button
                irxBotonIcono
                tamano="compacto"
                [activo]="!vistaEsAsignado(r)"
                (click)="alternarVista(r, 'principal')"
                [tooltip]="'Ver como ' + r.entidad"
              >
                <mat-icon>{{ r.icono }}</mat-icon>
              </button>
              <button
                irxBotonIcono
                tamano="compacto"
                [activo]="vistaEsAsignado(r)"
                (click)="alternarVista(r, 'asignado')"
                [tooltip]="'Ver como ' + r.asignadoEntidad"
              >
                <mat-icon>{{ r.asignadoIcono }}</mat-icon>
              </button>
            </div>
          } @else {
            <div class="resultado-card-icono">
              <mat-icon>{{ iconoActivo(r) }}</mat-icon>
            </div>
          }
          <div class="resultado-card-body">
            <span class="resultado-entidad">{{ entidadActiva(r) }}</span>

            <!-- Título: qué es (con chip opcional cuando no está alternado) -->
            <div class="resultado-titulo">
              @if (r.tituloChip && !vistaEsAsignado(r)) {
                <span class="resultado-chip">{{ r.tituloChip }}</span>
              }
              <span
                class="resultado-nombre"
                [matTooltip]="tituloActivo(r)"
                matTooltipShowDelay="300"
              >
                {{ tituloActivo(r) }}
              </span>
            </div>

            <!-- Cliente al que pertenece -->
            @if (r.cliente) {
              <div class="resultado-subtitulo">
                <span class="resultado-mini-label">Cliente</span>
                <span
                  class="resultado-subnombre"
                  [matTooltip]="r.cliente"
                  matTooltipShowDelay="300"
                >
                  {{ r.cliente }}
                </span>
              </div>
            }

            @if (r.detalle && !vistaEsAsignado(r)) {
              <span
                class="resultado-detalle"
                [matTooltip]="r.detalle"
                matTooltipShowDelay="300"
              >
                {{ r.detalle }}
              </span>
            }
            <span class="resultado-match">
              <mat-icon>call</mat-icon>
              {{ r.campo }}:
              <strong>{{ r.valor }}</strong>
            </span>
          </div>

          <!-- Lupa hacia el detalle de la entidad activa -->
          @if (rutaActiva(r); as ruta) {
            <div class="resultado-acciones">
              <a
                irxBotonIcono
                tono="primario"
                [routerLink]="ruta"
                [tooltip]="'Ver ' + entidadActiva(r).toLowerCase()"
              >
                <mat-icon>visibility</mat-icon>
              </a>
            </div>
          }
        </div>
      }
    </div>
  } @else {
    <app-empty-state
      icon="search"
      title="Buscar por teléfono"
      message="Escribí al menos 3 caracteres para buscar"
    ></app-empty-state>
  }
</div>
